var map = {
	"./aolenberg.mp4": 9694,
	"./astarczyk.mp4": 745,
	"./ayalcin.mp4": 1121,
	"./bdevletli.mp4": 7774,
	"./bleisten.mp4": 705,
	"./bniemeier.mp4": 1714,
	"./dlittau.mp4": 2150,
	"./dmanns.mp4": 1620,
	"./efrantzen.mp4": 8543,
	"./jctvrtnicek.mp4": 5287,
	"./jnickel.mp4": 6196,
	"./liolenberg.mp4": 5470,
	"./lolenberg.mp4": 5999,
	"./mmohnke.mp4": 775,
	"./nretzlaff.mp4": 5819,
	"./sdukkardt.mp4": 5879,
	"./skeilbach.mp4": 4826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2355;